<template>
  <div>
    <tree-view :tree="treeData" v-on:operate="operate"></tree-view>
  </div>
</template>

<script>
  import TreeView from '@/components/utils/tree-view'
  import { InterfaceManager } from '@/components/home/controllers/interface.js'

  export default {
    created () {
      this._imported = () => this.updateTreeData()

      this.$emitter.on('imported', this._imported)
      this.interfaceManager = new InterfaceManager(this)
      this.updateTreeData()

      this.interfaceManager.afterSubmitHook = () => {
        this.updateTreeData()
      }
    },
    destroyed () {
      this.$emitter.removeListener('imported', this._imported)
    },
    data () {
      return {
        treeData: []
      }
    },
    components: {
      TreeView
    },
    methods: {
      async operate (operation, data) {
        await this.interfaceManager.processOperation(operation, data)
        this.updateTreeData()
      },
      async updateTreeData () {
        this.treeData = await this.interfaceManager.genTreeData()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/trees/interface-tree.vue